import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-control-erro',
  templateUrl: './control-erro.component.html',
  styleUrls: ['./control-erro.component.scss']
})
export class ControlErroComponent implements OnInit {

  @Input() msgErro: string;
  @Input() mostrarErro: boolean;

  constructor() { }

  ngOnInit() {
  }

}
